import { Directive, HostListener } from '@angular/core';

@Directive({
  selector: 'input[type=number]'
})
export class DisableWheelDirective {

  @HostListener('wheel', ['$event'])
  onWheel(event: WheelEvent): void {
     if (document.activeElement === event.target) {
      event.preventDefault();
    }
  }

}
